import { useEffect, useState } from "react";
import { Col, Container, Row, Form, Button, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { apiService } from "../service/api.service";
import {
  baseUrl,
  allowedImageTypes,
  PasswordRegex,
  errorHandling,
} from "../config/config";
import Loader from "../common/Loader";
import { validateService } from "../service/validation.service";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setprofileImage } from "../store/index_slice";
import swal from "sweetalert";
const MyProfile = () => {
  const [show, setShow] = useState(false);
  const [showPass, setshowPass] = useState(false);
  const [showPassOld, setshowPassOld] = useState(false);
  const [showPassConfirm, setshowPassConfirm] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loader, setLoader] = useState(false);
  const [image, setImage] = useState();
  const [imageShow, setimageShow] = useState();
  const [imageErr, setImageErr] = useState();
  const [profileData, setprofileData] = useState();
  const [changePasswordFields, setchangePasswordFields] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });

  const [changePasswordFieldsErr, setchangePasswordFieldsErr] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });
  const dispatch = useDispatch();
  useEffect(() => {
    GetProfile();
  }, []);
  let history = useNavigate();
  function EditProfile() {
    history("/update-profile");
  }
  const GetProfile = () => {
    setLoader(true);
    apiService
      .GetProfile()
      .then((res) => {
        setLoader(false);
        setprofileData(res.data.data.user);
        localStorage.setItem("profile_status", res.data.data.user.status);
        localStorage.setItem(
          "stripeCustomerId",
          res.data.data.user.stripeCustomerId
        );
      })
      .catch((err) => {
        errorHandling(err.response.status);
        // if (err.response.status === 401) {
        //   swal({ icon: 'error', text: "Your session has been expired, please login again. ", button: "OK" }).then(() => {
        //     localStorage.clear()
        //     window.location.href = "/login"
        //   });

        // }
        setLoader(false);
        console.log(err);
        console.log("contact us api error", err.response);
      });
  };
  const uplodFile = (imagedata) => {
    setLoader(true);
    let datanew = new FormData();
    datanew.append("file", imagedata);
    apiService
      .uplodFile("image", datanew)
      .then((res) => {
        dispatch(setprofileImage(baseUrl + res.data.data.user.imagePath));
        localStorage.setItem(
          "profile_img",
          baseUrl + res.data.data.user.imagePath
        );
        GetProfile();
        setTimeout(() => {
          setLoader(false);
        }, 2000);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
        console.log("contact us api error", err.response);
      });
  };
  const changePassword = () => {
    let valid = validateService.resetpasswordvalidate(
      setchangePasswordFieldsErr,
      changePasswordFields
    );
    if (valid) {
      setLoader(true);
      apiService
        .changePassword(changePasswordFields)
        .then((res) => {
          setLoader(false);
          swal({
            title: "Success",
            text: "Password changed successfully, please log in again.",
            icon: "success",
            buttons: "Ok",
          }).then((confirmed) => {
            localStorage.clear();
            window.location.href = "/login";
          });

          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
          swal("Error", err.response.data.message, "error");
          console.log("contact us api error", err.response);
        });
    }
  };

  const handleImageChange = (file) => {
    const selectedImage = file;
    let valid = true;
    if (selectedImage) {
      console.log("=====");

      if (allowedImageTypes.includes(selectedImage.type)) {
        setImage(selectedImage);
        uplodFile(selectedImage);
        valid = true;
        const reader = new FileReader();
        reader.onload = () => {
          setimageShow(reader.result);
        };
        reader.readAsDataURL(selectedImage);
        setImageErr("");
      } else {
        valid = false;
        console.log(
          "Invalid file type. Please select a JPEG,JPG or PNG image."
        );
        setImageErr(
          "Invalid file type. Please select a JPEG,JPG or PNG image."
        );
      }
    }
    return valid;
  };
  const onInputChange = (field, value) => {
    if (field == "password") {
      checkPasswordStrngth(value);
      setchangePasswordFields({
        ...changePasswordFields,
        [field]: value,
      });
    } else {
      setchangePasswordFields({
        ...changePasswordFields,
        [field]: value,
      });
    }
  };
  const checkPasswordStrngth = (val) => {
    if (PasswordRegex.test(val)) {
      setchangePasswordFieldsErr({
        ...changePasswordFieldsErr,
        password: "",
      });
      return true;
    } else {
      setchangePasswordFieldsErr({
        ...changePasswordFieldsErr,
        password:
          "Password must be a minimum of 8 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character. ",
      });
    }
    return false;
  };
  return (
    <>
      <div className="height-footer">
        {loader && <Loader />}
        <Container>
          <div className="profile-outer-box">
            <div className="product-header-area">
              <h2 className="subheading-under">My Profile</h2>
              <div className="under-heading">
                <Button className="green-btn" onClick={handleShow}>
                  Change Password
                </Button>
                <Button
                  className="green-btn green-outline-btn"
                  onClick={() => EditProfile()}
                >
                  Edit Profile
                </Button>
              </div>
            </div>
            <div className="under-profile">
              <div className="profile-img">
                {profileData?.imagePath ? (
                  <img
                    className="my-profile-img"
                    src={
                      imageShow ? imageShow : baseUrl + profileData?.imagePath
                    }
                    alt="img"
                  />
                ) : (
                  <img
                    className="my-profile-img"
                    src={require("../assets/images/user-default.png")}
                    alt="img"
                  />
                )}
                <Form.Control
                  type="file"
                  onChange={(e) => handleImageChange(e.target.files[0])}
                />
                <img
                  className="edit-icon"
                  src={require("../assets/images/edit-icon.svg").default}
                  alt="img"
                />
                <span className="text-danger">{imageErr}</span>
              </div>
              <div className="review-box">
                {profileData?.cultivator?.totalReview != 0 &&
                <Link to="/reviews" className="text-decoration-one">
                  <p className="review-txt">
                    <span className="star-pattern">
                      <i className="fa-solid fa-star"></i>
                    </span>
                   <span className="green-txt text-decoration-one">
                      {profileData?.cultivator?.rating}
                    </span>{" "} 
                    ({profileData?.cultivator?.totalReview} {profileData?.cultivator?.totalReview==1?"review":"reviews"})
                  </p>
                </Link>}
               </div>
              <Row>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">First Name</p>
                    <p className="profile-details">
                      {profileData?.firstName ? profileData?.firstName : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Last Name</p>
                    <p className="profile-details">
                      {profileData?.lastName ? profileData?.lastName : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Email Address</p>
                    <p className="profile-details">
                      {profileData?.email ? profileData?.email : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Phone Number</p>
                    <p className="profile-details">
                      {profileData?.phone ? "+" + profileData?.phone : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Gender</p>
                    <p className="profile-details">
                      {profileData?.gender ? profileData?.gender : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Business Name</p>
                    <p className="profile-details">
                      {profileData?.cultivator?.businessName
                        ? profileData?.cultivator.businessName
                        : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Years of Experience</p>
                    <p className="profile-details">
                      {profileData?.cultivator
                        ? profileData?.cultivator?.yearOfExperience
                        : "N/A"}
                    </p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Type of Cultivation</p>
                    <p className="profile-details">
                      {profileData?.cultivator
                        ? profileData?.cultivator?.typeOfCultivation
                        : "N/A"}
                    </p>
                  </div>
                </Col>

                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Address</p>
                    <p className="profile-details">
                      {profileData?.address ? profileData?.address : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">City</p>
                    <p className="profile-details">
                      {profileData?.cultivator
                        ? profileData?.cultivator?.city
                        : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col sm={6} md={4} lg={4}>
                  <div className="customer-info">
                    <p className="customer-id">Country</p>
                    <p className="profile-details">
                      {profileData?.cultivator
                        ? profileData?.cultivator?.country
                        : "N/A"}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <Form.Label>ID Proof</Form.Label>
                  <div className="profile-id-bottom">
                    <div className="id-front me-3">
                      <div className="">
                        <div className="upload-document position-relative">
                          <div>
                            <img
                              className="file-upload-show"
                              src={
                                profileData?.cultivator?.idProofFront? baseUrl +
                                    profileData.cultivator.idProofFront
                                  : require("../assets/images/upload.svg")
                                      .default
                              }
                              alt="img"
                            />
                          </div>
                        </div>
                        <h5 className="upload-text">
                          {" "}
                          Id<span>(Front side)</span>
                        </h5>
                      </div>
                    </div>
                    <div className="id-front">
                      <div className="">
                        <div className="upload-document position-relative">
                          <div>
                            <img
                              className="file-upload-show"
                              src={
                                profileData?.cultivator?.idProofBack
                                  ? baseUrl + profileData.cultivator.idProofBack
                                  : require("../assets/images/upload.svg")
                                      .default
                              }
                              alt="img"
                            />
                          </div>
                        </div>
                        <h5 className="upload-text">
                          {" "}
                          <span>(Back side)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </Col>
                {profileData?.status == "Reject" && (
                  <Col lg={4}>
                    <div className="customer-info">
                      <p className="customer-id rejection-reason">
                        Rejection Reason
                      </p>
                      <p className="profile-details">
                        {profileData?.reason ? profileData?.reason : "N/A"}
                      </p>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Container>
      </div>
      {/* success modal */}
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-success"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton className="border-0">
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="modal-success-body">
            <Form className="login-body">
              <Form.Group className="mb-3 position-relative">
                <Form.Label>Current Password</Form.Label>
                <Form.Control
                  type={showPassOld ? "text" : "password"}
                  placeholder="Enter Current Password"
                  onChange={(e) => onInputChange("oldPassword", e.target.value)}
                />
                {showPassOld ? (
                  <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={() => setshowPassOld(false)}
                    alt="img"
                  />
                ) : (
                  <img
                    className="eye-icon"
                    onClick={() => setshowPassOld(true)}
                    src={require("../assets/images/eye (1).svg").default}
                    alt="img"
                  />
                )}
                <span className="text-danger">
                  {changePasswordFieldsErr.oldPassword}
                </span>
                {/* <img
                  className="eye-icon"
                  src={require("../assets/images/eye-crossed 1.svg").default}
                  alt="img"
                /> */}
              </Form.Group>
              <Form.Group className="mb-3 position-relative">
                <Form.Label>New New Password</Form.Label>
                <Form.Control
                  type={showPass ? "text" : "password"}
                  placeholder="Enter New Password"
                  onChange={(e) => onInputChange("password", e.target.value)}
                />
                {showPass ? (
                  <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={() => setshowPass(false)}
                    alt="img"
                  />
                ) : (
                  <img
                    className="eye-icon"
                    onClick={() => setshowPass(true)}
                    src={require("../assets/images/eye (1).svg").default}
                    alt="img"
                  />
                )}
                {/* <img
                  className="eye-icon"
                  src={require("../assets/images/eye-crossed 1.svg").default}
                  alt="img"
                /> */}
                <span className="text-danger">
                  {changePasswordFieldsErr.password}
                </span>
              </Form.Group>
              <Form.Group className="mb-3 position-relative">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type={showPassConfirm ? "text" : "password"}
                  placeholder="Enter Confirm Password"
                  onChange={(e) =>
                    onInputChange("confirmPassword", e.target.value)
                  }
                />
                {showPassConfirm ? (
                  <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={() => setshowPassConfirm(false)}
                    alt="img"
                  />
                ) : (
                  <img
                    className="eye-icon"
                    onClick={() => setshowPassConfirm(true)}
                    src={require("../assets/images/eye (1).svg").default}
                    alt="img"
                  />
                )}
                {/* <img
                  className="eye-icon"
                  src={require("../assets/images/eye-crossed 1.svg").default}
                  alt="img"
                /> */}
                <span className="text-danger">
                  {changePasswordFieldsErr.confirmPassword}
                </span>
              </Form.Group>
              <Button className="green-btn" onClick={changePassword}>
                Update
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default MyProfile;
